import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPermissionsResponse, PermissionState, UpdatePermissionRoleDTO } from './types';

export const initialState: PermissionState = {
  loading: false,
  byRoleId: {},
};

const permissionSlice = createSlice({
  name: 'PERMISSION',
  initialState,
  reducers: {
    reset: () => initialState,
    ['GET_PERMISSIONS']: (state) => ({
      ...state,
      loading: true,
    }),
    ['GET_PERMISSIONS:OK']: (state, action: PayloadAction<getPermissionsResponse>) => ({
      ...state,
      loading: false,
      byRoleId: action.payload.data.byRoleId,
    }),
    ['UPDATE_PERMISSIONS']: (state, action: PayloadAction<UpdatePermissionRoleDTO>) => {
      const { value, target_role_id, permission } = action.payload;
      const permissions = new Set(state.byRoleId[target_role_id]);

      if (value) {
        permissions.add(permission);
      } else {
        permissions.delete(permission);
      }

      return {
        ...state,
        byRoleId: {
          ...state.byRoleId,
          [target_role_id]: Array.from(permissions),
        },
      };
    },
  },
});

export default permissionSlice;
